import {
  ThemeUICSSObject,
  getColorsByPath,
  responsive,
  spacing,
} from '@apia/theme';
import { gridSpan } from '../groups';
import environments from './environments';
import selectedFunc from './selectedFunc';
/* IMPORT HERE */

const profiles: ThemeUICSSObject = {
  environments,
  selectedFunc,
  upsertion: {
    fieldset: {
      display: 'grid',
      gridTemplateColumns: responsive({
        0: '1fr',
        2: 'repeat(2, 1fr)',
        4: 'repeat(4, 1fr)',
      }),
      gap: spacing(4),
      p: spacing(7),
      border: 'none',
      ...getColorsByPath('tab'),

      // '.substitutionList': {
      //   gridColumnStart: 0,
      //   gridColumnEnd: responsive({
      //     0: 1,
      //     2: 2,
      //     4: 4,
      //   }),
      // },
    },
    '.addingContainer': {
      display: 'block',

      justifyContent: 'start',
      gridColumn: gridSpan,
    },

    '.addFunAndDash': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whitespace: 'nowrap',
      gap: spacing(4),
      display: 'flex',
      flexDirection: 'column',
    },
    '.addFunAndDash__title': {
      width: 'max-content',
    },
    '& .treeContainer': {
      pb: spacing(4),
    },
    '.tree': {
      maxHeight: '50vh',
      height: '50vh',
      width: '100%',
      overflow: 'auto',
      border: '1px solid',
      borderColor: 'palette.border.section',
      p: spacing(6),
      '.tree__leaf__label ': {
        gap: 0,
      },
      '.tree__leaf__label section': {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
      },
      '.tree__leaf__label svg': {
        flexShrink: 0,
      },
    },

    '.imageAndEnvSelector ': {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(3),
      marginBottom: '15px',
    },
    '.deleteFuncAndDash': {
      border: 'none',
      background: 'none',
      padding: 0,
      justifyContent: 'center',
      display: 'flex',
      '& :hover': {
        border: 'none',
        background: 'none',
        padding: 0,
        justifyContent: 'center',
        display: 'flex',
      },
    },
    '.environmentTitle': {
      mt: spacing(4),
      mb: spacing(3),
      borderBottomWidth: '2px',
      borderBottomStyle: 'solid',
      borderBottomColor: 'palette.primary.main',
      width: 'fit-content',
    },

    '.imageSelector': {
      gridColumn: gridSpan,
      alignItems: 'start',
      width: 'fit-content',
      '&>div': { gap: spacing(0) },
    },

    '.environmentsSelector': {
      gridColumn: gridSpan,

      display: 'block',
      span: {
        fontWeight: 'bold',
      },

      '.environments': {
        display: 'flex',
        flexWrap: 'wrap',
        listStyle: 'none',
        gap: spacing(4),
        padding: 0,
        marginTop: 0,
        mb: spacing(4),
      },
    },

    '.textarea': {
      gridColumn: gridSpan,

      textarea: {
        height: '15vh',
        mt: spacing(1),
      },
    },

    '& label': {
      display: 'block',
    },
    '.addFunctionality': {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(3),
      px: 1,
    },
    '.addDashboard': {
      display: 'flex',
      flexDirection: 'column',
      gap: spacing(3),
      px: 1,
    },
    '.addDashOrFun__addBtn': {
      width: '260px',
    },
    '.box_spinner': {
      display: 'flex',
      justifyContent: 'center',
    },
    '.selectedDashboards__container': {
      pb: spacing(4),
    },
    '.selectedDashboards__list': {
      flexDirection: 'column',
      display: 'flex',
      gap: spacing(3),
      border: '1px solid',
      borderColor: 'palette.border.section',
      padding: 5,
    },
    '.selectedDashboards__item': {
      flexDirection: 'row',
      display: 'flex',
      alignItems: 'center',
      gap: 3,
    },
    '.selectedDashboards__item span': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },
};

export default profiles;
